





















































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { mapState } from 'vuex';

import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import MapOutline from '~/components/icons/MapOutline.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import ProviderCard from '~/components/cards/ProviderCard.vue';
import LocalisationProvidersMobileModal from '~/components/lists/items/LocalisationProvidersMobileModal.vue';

const Modal = {
  MOBILE_PROVIDERS: 'providers',
};

@Component({
  components: {
    CheckBoxesDropdown,
    MapOutline,
    CheckInput,
    ProviderCard,
    LocalisationProvidersMobileModal,
  },
  computed: {
    ...mapState([
      'isMobileDownloadBannerDisplayed',
    ]),
    ...mapState('explorer', [
      'displayLocalisationMap',
      'mobileLocalisationFiltersModal',
      'destinationProvidersFilters',
      'destinationProviders',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class LocalisationProviders extends Vue {
  @Prop(Array) providers: [];

  $refs: {
    providerTab: HTMLDivElement,
  }

  isMobileDownloadBannerDisplayed : boolean;
  displayLocalisationMap: boolean;
  mobileLocalisationFiltersModal: string;
  destinationProvidersFilters: {[key: string]: any};
  destinationProviders: Types.ProviderList;
  locale: string;

  Modal = Modal;
  modal: string = '';

  providerTypes: Array<Types.CheckboxElement> = [
    { checked: false, id: 'FOOD', name: this.$t('localisationProviders.types.eat') },
    { checked: false, id: 'SHOP', name: this.$t('localisationProviders.types.shop') },
    { checked: false, id: 'TODOTOSEE', name: this.$t('localisationProviders.types.todosee') },
    { checked: false, id: 'HOSTING', name: this.$t('localisationProviders.types.hosting') },
    { checked: false, id: 'SERVICE', name: this.$t('localisationProviders.types.service') },
  ];

  selectedProviders: Array<any> = [];
  respects: boolean = false;

  calculatedDivHeight: number = 300;
  cantDoMore: boolean = false;

  emitHasScrolled () {
    if (this.providers.length && (this.providers.length !== this.destinationProviders.total)) {
      this.$emit('load-providers');
    }
  }

  @Emit('search-providers')
  searchProviders () {
    return {
      providerTypes: this.selectedProviders.map((t: Types.CheckboxElement) => t.id),
      providerRespect: this.respects,
    };
  }

  @Watch('mobileLocalisationFiltersModal')
  handleModalDisplay (val: string) {
    if (val === Modal.MOBILE_PROVIDERS) this.modal = Modal.MOBILE_PROVIDERS;
  }

  @Watch('destinationProvidersFilters')
  populate () {
    if (!this.cantDoMore) {
      if (this.destinationProvidersFilters.providerTypes) {
        this.destinationProvidersFilters.providerTypes.map((t: string) => {
          this.selectedProviders.push({ id: t });
          this.providerTypes.map((p: Types.CheckboxElement) => {
            if (p.id === t) p.checked = true;
          });
        });
      }

      if (this.destinationProvidersFilters.providerRespect) this.respects = this.destinationProvidersFilters.providerRespect;
    }
    this.cantDoMore = true;
  }

  mounted () {
    this.handleHeight();

    window.addEventListener('resize', this.handleHeight);

    this.populate();
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleHeight);
  }

  handleModalClose () {
    this.modal = '';
    this.$store.commit('explorer/SET_MOBILE_LOCALISATION_FILTERS_MODAL', '');
  }

  handleHeight () {
    this.calculatedDivHeight = this.$refs.providerTab.clientHeight + 133;
  }

  /* eslint array-callback-return: 0 */
  populateFilterArray (data: any) {
    const self: any = this;
    const vueData: any = self[data.data];
    const isDuplicated: any = vueData.filter((item: any) => item.id === data.element.id).length === 1;
    if (!isDuplicated) {
      vueData.push(data.element);
    } else {
      vueData.map((filter: any, index: number) => {
        if (filter.id === data.element.id) {
          vueData.splice(index, 1);
        }
      });
    }
    return vueData.slice(0);
  }

  resetFilters () {
    /* eslint no-return-assign: 0 */
    this.providerTypes.forEach((d: Types.CheckboxElement) => d.checked = false);
    this.selectedProviders = [];
    this.respects = false;
    this.$root.$emit('reset-checkboxes');
  }
}
